<div class="form-field-container d-flex flex-column {{ className }}" [formGroup]="formGroup" [ngStyle]="{
    '--border-color': control.disabled ? 'var(--mdc-outlined-text-field-disabled-outline-color)' : control.touched && control.invalid ? 'red' : '#afcbe0'
  }">
  <div style="clear: both;">
    <label>{{ label }}</label>
    <label style="float: right;font-size:12px" [ngStyle]="{ opacity: control.disabled ? 0.7 : 1}">Brug link til event/personlig aftale <input style="vertical-align: middle;" type="checkbox" [disabled]="control.disabled" [checked]="useEventUrl" (change)="onUseEventUrlChange($event)" /></label>
  </div>
  <mat-form-field appearance="outline" class="position-relative">
    @if (useEventUrl && event) {
    <input matInput [value]="event.link" readonly="true" [disabled]="control.disabled" />
    }
    @else if (useEventUrl && !event) {
    <input matInput placeholder="Intet event/personligt aftale valgt" readonly="true" [disabled]="control.disabled" value="" />
    }
    @else {
    <input matInput placeholder="{{ placeholder }}" [formControlName]="controlName" [disabled]="control.disabled" />
    }

    @if (enablePasteButton && !this.control.disabled && !useEventUrl) {
    <mat-icon matSuffix style="margin-top:-8px;" matTooltip="Indsæt fra udklipsholder" (click)="onPasteButtonClick()">content_paste</mat-icon>
    }

    @if (control.touched && control.invalid) {
    <div class="position-absolute form-validation-error-container">
      @if (control.errors?.['ctaUrl']) {
      <small>Feltet skal være tomt eller indeholde en gyldig URL eller reference</small>
      }
    </div>
    }
  </mat-form-field>
</div>
